import type { Address } from "viem"
import type { Config } from "wagmi"
import { readContract } from "@wagmi/core"

export const thickV2PoolSwapFeeAbi = [
  {
    inputs: [],
    name: "fee",
    outputs: [{ internalType: "uint24", name: "", type: "uint24" }],
    stateMutability: "view",
    type: "function",
  },
] as const

export async function poolSwapFee({
  poolAddress,
  chainId,
  config,
}: {
  poolAddress: Address
  chainId: number
  config: Config
}): Promise<number> {
  const fee = await readContract(config, {
    abi: thickV2PoolSwapFeeAbi,
    address: poolAddress,
    chainId,
    functionName: "fee",
  })

  return Number(fee)
}
